export default "__VITE_ASSET__BgwC6BED__"